"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressSearch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var AddressSearch = function (props) {
    var _a = props.letsTradeAPIUrl, letsTradeAPIUrl = _a === void 0 ? process.env.LETS_TRADE_CLIENT_URL : _a, fullAddress = props.fullAddress, onSelectionChange = props.onSelectionChange, _b = props.label, label = _b === void 0 ? "Address" : _b, _c = props.placeholder, placeholder = _c === void 0 ? "Enter address" : _c, required = props.required, errorMessage = props.errorMessage, className = props.className, variant = props.variant;
    var _d = (0, react_2.useState)([]), predictions = _d[0], setPredictions = _d[1];
    var _e = (0, react_2.useState)(""), addressInput = _e[0], setAddressInput = _e[1];
    var _f = (0, react_2.useState)(null), selectedKey = _f[0], setSelectedKey = _f[1];
    (0, react_2.useEffect)(function () {
        setSelectedKey(fullAddress);
    }, [fullAddress]);
    (0, react_2.useEffect)(function () {
        if (addressInput) {
            var timeout_1 = setTimeout(function () {
                fetch("".concat(letsTradeAPIUrl, "/v2/google/autocomplete?input=").concat(addressInput), {
                    method: "GET",
                })
                    .then(function (response) { return response.json(); })
                    .then(function (data) {
                    if (data.success) {
                        setPredictions(data.content);
                    }
                    else {
                        console.log("Address Search ERROR", data.message);
                    }
                });
            }, 1000);
            return function () { return clearTimeout(timeout_1); };
        }
    }, [addressInput]);
    var handleSelectionChange = function (key) {
        var address = predictions.find(function (item) { return item.description === key; });
        if (!address) {
            console.log("Address Select ERROR on find", key);
            return;
        }
        var place_id = address.place_id;
        fetch("".concat(letsTradeAPIUrl, "/v2/google/placeiddetails?place_id=").concat(place_id), {
            method: "GET",
        })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            var _a, _b, _c, _d, _e, _f, _g;
            if (!data.success) {
                console.log("Address Select ERROR", data.message);
                return;
            }
            var _h = data.content, geometry = _h.geometry, address_components = _h.address_components;
            var lat = geometry.location.lat.toString();
            var lng = geometry.location.lng.toString();
            var obj = {
                fullAddress: address.description,
                coordinates: {
                    lat: lat.toString(),
                    lng: lng.toString(),
                },
                street_number: (_a = address_components.find(function (c) { return c.types.includes("street_number"); })) === null || _a === void 0 ? void 0 : _a.long_name,
                street_name: (_b = address_components.find(function (c) { return c.types.includes("route"); })) === null || _b === void 0 ? void 0 : _b.long_name,
                suburb: (_c = address_components.find(function (c) { return c.types.includes("sublocality"); })) === null || _c === void 0 ? void 0 : _c.long_name,
                city: (_d = address_components.find(function (c) { return c.types.includes("locality"); })) === null || _d === void 0 ? void 0 : _d.long_name,
                province: (_e = address_components.find(function (c) { return c.types.includes("administrative_area_level_1"); })) === null || _e === void 0 ? void 0 : _e.long_name,
                country: (_f = address_components.find(function (c) { return c.types.includes("country"); })) === null || _f === void 0 ? void 0 : _f.long_name,
                postal_code: (_g = address_components.find(function (c) { return c.types.includes("postal_code"); })) === null || _g === void 0 ? void 0 : _g.long_name,
            };
            setSelectedKey(address.description);
            onSelectionChange && onSelectionChange(obj);
        });
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.ComboBox, { className: className, variant: variant, isRequired: required, isInvalid: !!errorMessage, inputValue: addressInput, onInputChange: setAddressInput, selectedKey: selectedKey, onSelectionChange: handleSelectionChange, allowsCustomValue: true, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: label }), (0, jsx_runtime_1.jsxs)(react_1.ComboBox.InputGroup, { children: [(0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: placeholder }), (0, jsx_runtime_1.jsx)(react_1.ComboBox.Trigger, {})] }), (0, jsx_runtime_1.jsx)(react_1.ComboBox.Popover, { children: (0, jsx_runtime_1.jsx)(react_1.ListBox, { items: predictions, children: function (item) { return ((0, jsx_runtime_1.jsxs)(react_1.ListBox.Item, { id: item.description, textValue: item.description, children: [item.description, (0, jsx_runtime_1.jsx)(react_1.ListBox.ItemIndicator, {})] })); } }) }), errorMessage ? (0, jsx_runtime_1.jsx)(react_1.FieldError, { children: errorMessage }) : null] }));
};
exports.AddressSearch = AddressSearch;
